import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import { Box } from '@mui/material';
// component
import { useDebounce } from 'usehooks-ts';
import ComfirmSend from '@/component/send/ComfirmSend';
import SendBtn from './SendBtn';
import Loading from '../mui/Backdrop';
import SendSuccess from '../../page/wallet/SendSuccess';
import { TransactionReceipt, utils } from 'web3';
// hook
import { useWeb3 } from '@/hooks/use-web3';
// lib & store
import { useSendNftInfo } from '@/store/zustand/store';
import { telegramForm } from '@/lib/error-bot/telegram';
// type
import { SendContractType, SendErc721Type } from '@/types';
import { explorerUrlFilter } from '@/filter/explorerUrl';

export type Erc721TokenProps = {
  fromAddr: `0x${string}`;
  toAddr: `0x${string}`;
  contract: `0x${string}`;
  tokenId: string;
  tokenType: string;
};
export default function Erc721Token() {
  const navigate = useNavigate();
  const sendNftInfo = useSendNftInfo() as unknown as Erc721TokenProps;
  const { fromAddr, toAddr, contract, tokenId, tokenType } = sendNftInfo;
  // const debouncedTokenId = useDebounce(tokenId, 500);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { web3authCall } = useWeb3();
  const txhash = useRef('');
  const [typeLogin, setTypeLogin] = useState('');

  useEffect(() => {
    if (isSubmit && web3authCall?.connected) {
      (async () => {
        try {
          const payload: SendErc721Type = {
            contractAddr: contract,
            from: fromAddr,
            to: toAddr,
            tokenId,
            tokenType,
          };
          const re = await web3authCall.getRpc().sendNft(payload);
          console.log(re);
          txhash.current = re;
          setIsSuccess(true);
        } catch (e) {
          console.log(e);
          const text = `type: erc721_ContractWrite(), fromAddr: ${fromAddr}, toAddr: ${toAddr}, contract: ${contract}, tokenId: ${tokenId} meg: ${e}`;
          telegramForm(text);
          sendFail('전송실패');
          setIsSubmit(false);
        }
      })();
    }

    return () => {};
  }, [isSubmit]);

  useEffect(() => {
    if (isSuccess) {
      navigate('/sendSuccess', {
        state: {
          type: 'nft',
          data: {
            hash: txhash.current,
            // blockExplorerUrl: provider?.chainConfig?.blockExplorerUrl,
          },
        },
      });
    }
    return () => {};
  }, [isSuccess]);

  // const { config, error: isPrepareError } = usePrepareContractWrite({
  //   address: contract, // 컨트랙트 주소
  //   abi: erc721ABI,
  //   functionName: 'safeTransferFrom',
  //   args: [fromAddr, toAddr, parseUnits(tokenId, 0)],
  //   enabled: Boolean(debouncedTokenId),
  //   cacheTime: 10000,
  // });
  // const { write, data, isLoading, isSuccess, isError, error: prepareError, error } = useContractWrite(config);
  // const { isLoading, isSuccess } = useWaitForTransaction({
  //   hash: data?.hash,
  //   cacheTime: 10000,
  // });
  // useEffect(() => {
  //   if (isSubmit) {
  //     write?.();
  //   }
  //   return () => {};
  // }, [isSubmit]);

  // useEffect(() => {
  //   if (isPrepareError) {
  //     const text = `type: erc721_usePrepareContractWrite(), fromAddr: ${fromAddr}, toAddr: ${toAddr}, contract: ${contract}, tokenId: ${tokenId}, meg: ${prepareError?.message}`;
  //     telegramForm(text);
  //     sendFail(prepareError?.message);
  //   }
  //   if (isError) {
  //     const text = `type: erc721_useContractWrite(), fromAddr: ${fromAddr}, toAddr: ${toAddr}, contract: ${contract}, tokenId: ${tokenId}, meg: ${error?.message}`;
  //     telegramForm(text);
  //     sendFail(error?.message);
  //   }

  //   return () => {};
  // }, [isError, isPrepareError]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     navigate('/sendSuccess', {
  //       state: {
  //         type: 'nft',
  //         data: data,
  //       },
  //     });
  //   }
  //   return () => {};
  // }, [isSuccess]);

  const sendFail = (msg: string | undefined) => {
    navigate('/sendFail', {
      state: {
        data: msg,
      },
    });
  };
  return (
    <>
      <ComfirmSend type="erc721" symbol="" />
      {isSubmit && (
        <>
          {typeLogin === 'external' ? (
            <Loading
              isLoading={isSubmit}
              text="사용할 전자지갑에서 전송 승인 완료 후 셔플을 실행하여 전송결과를 확인하세요."
            />
          ) : (
            <Loading isLoading={isSubmit} />
          )}
        </>
      )}
      {/* {isLoading && <Loading isLoading={isLoading} />} */}
      {/* {(isPrepareError || isError) && <div>Error: {(prepareError || error)?.message}</div>} */}

      <Box mb={5} />
      <SendBtn setIsSubmit={setIsSubmit} setTypeLogin={setTypeLogin} />
    </>
  );
}
